<template>
  <div>
    <ts-card class="m-t-10 m-b-10">
      <h1 class="section-divider text-primary">
        {{ $t('homePage.subject') }}
      </h1>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-md-4"
            v-for="(subject, index) in subjectLists"
            :key="index"
          >
            <div class="item">
              <div class="icon">
                <i class="fa fa-book fa-2x"></i>
              </div>
              <div class="content">
                <h3 class="widget-list-title">{{ subject.subject_name }}</h3>
                <small class="widget-list-desc">
                  {{ subject.subject_name_native }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </ts-card-wrapper>
      <h1 class="section-divider text-primary">
        {{ $t('homePage.experience') }}
      </h1>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-md-4"
            v-for="(experience, index) in profile.experiences"
            :key="index"
          >
            <div class="item">
              <div class="icon">
                <i class="fas fa-briefcase fa-2x"></i>
              </div>
              <div class="content">
                <h3 class="widget-list-title">
                  {{
                    experience.subject
                      ? experience.subject.subject_name_foreign
                      : ''
                  }}
                  at {{ experience.institution }}
                </h3>
                <small class="widget-list-desc">
                  {{
                    dateFormat(experience.from_date) +
                      ' - ' +
                      dateFormat(experience.to_date)
                  }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </ts-card-wrapper>
      <h1 class="section-divider text-primary">
        {{ $t('homePage.skill') }}
      </h1>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-md-4"
            v-for="(skill, index) in profile.skills"
            :key="index"
          >
            <div class="item">
              <div class="icon">
                <i class="fas fa-building fa-2x"></i>
              </div>
              <div class="content">
                <h3 class="widget-list-title">
                  {{ skill.skill_description }}
                </h3>
                <small class="widget-list-desc">
                  {{
                    dateFormat(skill.from_date) +
                      ' - ' +
                      dateFormat(skill.to_date)
                  }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
    <div class="row">
      <div class="col-lg-6 col-md-12 col-sm-12">
        <panel
          :title="$t('homePage.current')"
          variant="default"
          noButton="true"
        >
          <current-grade />
        </panel>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12">
        <panel
          :title="$t('homePage.history')"
          variant="default"
          noButton="true"
        >
          <history-grade />
        </panel>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import CurrentGrade from './current-grade'
import HistoryGrade from './history-grade'

export default {
  name: 'programGrade',
  components: {
    CurrentGrade,
    HistoryGrade
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('home/teacher', ['profile']),
    ...mapState('home/teacherHomework', ['subjectLists'])
  },
  methods: {
    dateFormat(date) {
      if (date) {
        return moment(date, 'DD-MM-YYYY').format('DD-MMM-YYYY')
      }
    }
  }
}
</script>
<style scoped>
.section-divider {
  border-bottom: 1px solid #eee;
  padding: 4px;
}
.item {
  display: table;
  text-decoration: none;
}
.item .icon {
  width: 20px;
  height: 20px;
  padding-top: 13px;
  padding-bottom: 5px;
}
.item .content {
  padding: 10px;
  display: table-cell;
  vertical-align: middle;
}
</style>
